import { ReactNode } from "react";

import Image from "common/components/Image";

// TODO reevaluate these images with new client updates
import pawBadge from "client/onboarding/images/paw-badge.svg";
import phone from "client/onboarding/images/phone.svg";
import store from "client/onboarding/images/clinic.svg";
import truck from "client/onboarding/images/truck.svg";
import { useClinic } from "client/clinics/hooks";
import { genSubscriptionDiscountContent } from "client/subscriptions/utils";

import styles from "../styles/OnboardingSubscriptionsHelp.module.less";

export type OnboardingSubscriptionsHelpInfoItemProps = {
  title: string;
  image: string;
  imageAlt: string;
  children: ReactNode;
};

const OnboardingSubscriptionsHelpInfoItem = ({
  title,
  image,
  imageAlt,
  children,
}: OnboardingSubscriptionsHelpInfoItemProps) => {
  return (
    <div key={title} className={styles.infoItem}>
      <Image src={image} alt={imageAlt} className={styles.infoImage} />
      <div>
        <div className={styles.infoTitle}>{title}</div>
        <div className={styles.infoDescription}>{children}</div>
      </div>
    </div>
  );
};

const OnboardingSubscriptionsHelp = () => {
  const {
    first_subscription_discount: firstDiscount,
    recurring_subscription_discount: recurringDiscount,
  } = useClinic();
  const discountText = genSubscriptionDiscountContent(firstDiscount, recurringDiscount, {
    none: () => "", // handle separately
    onlyFirst: (first) => `${first} off your first order`,
    onlyRecurring: (recurring) => `${recurring} off recurring orders`,
    both: (first, recurring) =>
      `${first} off your first order and ${recurring} off recurring orders`,
  });
  const infoItems: OnboardingSubscriptionsHelpInfoItemProps[] = [
    {
      image: store,
      imageAlt: "Clinic",
      title: "Autoship subscriptions",
      children: discountText
        ? `Save up to ${discountText} when you subscribe to automatic refills delivered to your home.`
        : "Enjoy convenience when you subscribe to automatic refills delivered to your home. Easily modify and skip orders, or cancel at any time.",
    },
    {
      image: truck,
      imageAlt: "Delivery truck",
      title: "Quick home delivery",
      children:
        "We ship straight to your door and always provide tracking information to keep you updated on your order.",
    },
    {
      image: phone,
      imageAlt: "Mobile Phone",
      title: "Synced to medical records",
      children:
        "Your vet will track your orders in your pet's medical history to have a clear picture of your pet's health during your next visit.",
    },
  ];
  return (
    <div className={styles.layout}>
      <Image className={styles.iconImage} src={pawBadge} alt="Guarantee Badge" />
      <div className={styles.title}>Your pet&apos;s online store</div>
      <div className={styles.description}>
        Our online store makes it easy to manage and shop all your pet&apos;s medication,
        preventative, and diet needs. Quality and safety are our top priorities when filling
        prescriptions for your pet.
      </div>
      <div className={styles.infoItems}>
        {infoItems.map((item) => (
          <OnboardingSubscriptionsHelpInfoItem key={item.title} {...item} />
        ))}
      </div>
    </div>
  );
};

export default OnboardingSubscriptionsHelp;
